<template>
  <div style="padding: 0 10px">
    <h4 v-show="source.length === 0" style="color: coral;text-align: center;">
      未查找到数据
    </h4>
    <el-row
      v-for="(item, index) in source"
      style="margin-bottom:10px"
      :key="index"
    >
      <TaskRecordCard
        :record.sync="source[index]"
        @select="select"
        :isCheckbox="isCheckbox"
        @successed="successed"
      ></TaskRecordCard>
    </el-row>
  </div>
</template>
//多个工作记录查看
<script>
import {
  GetRecordsByTaskId,
  GetRecordInfoByMainId
} from "@/api/modules/basicData/task";
import TaskRecordCard from "./TaskRecordCard.vue";
export default {
  name: "RecordCollection",
  components: {
    TaskRecordCard
  },
  props: {
    taskIds: {
      type: Array, //
      default: () => []
    },
    outSource: {
      type: Array,
      default: () => []
    },
    isCheckbox: Boolean
  },
  data() {
    return {
      source: []
    };
  },
  watch: {
    //多个任务查看工作记录
    taskIds(newValue) {
      if (newValue && newValue.length > 0) {
        GetRecordsByTaskId(newValue.join(","), 0).then(result => {
          if (result) {
            this.source = result;
          }
        });
      }
    },
    outSource(newValue) {
      if (newValue) {
        console.log("outSource", newValue);
        this.source = newValue;
      } else {
        this.source = [];
      }
    }
    // outSource: {
    //   handler: function(newValue) {
    //     if (newValue) {
    //       console.log("outSource", newValue);
    //       this.source = newValue;
    //     } else {
    //       this.source = [];
    //     }
    //   },
    //   immediate: true
    // }
  },
  methods: {
    successed() {
      this.$emit("successed");
    },
    select(row, isAddOrDelete) {
      this.$emit("select", row, isAddOrDelete);
    }
  }
};
</script>

<style lang="scss" scoped></style>
